import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

import {ApolloClient} from 'apollo-client';
import { HttpLink } from 'apollo-link-http';
import { ApolloLink, concat } from 'apollo-link';
import { ApolloProvider } from 'react-apollo';
import { InMemoryCache } from 'apollo-cache-inmemory';
import {typeDefs} from './schemas.jsx'

const httpLink = new HttpLink({ uri: 'https://ubelens.myshopify.com/api//graphql' });


// Add authentication headers
const authMiddleware = new ApolloLink((operation, forward) => {
  // add the authorization to the headers
    operation.setContext({
      headers: {
        'X-Shopify-Storefront-Access-Token': '81f7361b52e2f2f6aa10b2d4d1b3dc70',
        'Accept':'application/json'
      } 
    });

    return forward(operation);
  })

  const client = new ApolloClient({
  link: concat(authMiddleware, httpLink),
  cache: new InMemoryCache().restore(window.__APOLLO_STATE__),
  typeDefs
  
});


ReactDOM.render(
    <ApolloProvider client={client}>
      <App client={client}/>
    </ApolloProvider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
